import type { SVGProps, ReactElement } from 'react'

type Props = SVGProps<SVGSVGElement>

const PlayArrowRoundedSvg = ({ ...props }: Props): ReactElement | null => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M6.88281 33.4088V6.5911C6.88281 5.85695 7.14192 5.24114 7.66014 4.74365C8.17836 4.24616 8.78294 3.99828 9.4739 4.00001C9.68982 4.00001 9.91697 4.03197 10.1554 4.09588C10.3937 4.15979 10.62 4.25739 10.8342 4.38867L31.9516 17.7975C32.3402 18.0567 32.6322 18.3805 32.8274 18.7692C33.0226 19.1579 33.1193 19.5681 33.1176 20C33.1158 20.4318 33.0191 20.8421 32.8274 21.2307C32.6356 21.6194 32.3437 21.9433 31.9516 22.2024L10.8342 35.6113C10.6183 35.7408 10.392 35.8384 10.1554 35.9041C9.9187 35.9697 9.69155 36.0017 9.4739 35.9999C8.78294 35.9999 8.17836 35.7512 7.66014 35.2537C7.14192 34.7562 6.88281 34.1413 6.88281 33.4088Z" fill="#E4DFEA" />
    </svg>
  )
}

export default PlayArrowRoundedSvg
